import { render, staticRenderFns } from "./DanhSachNoTienPhong.vue?vue&type=template&id=cc27526c"
import script from "./DanhSachNoTienPhong.vue?vue&type=script&lang=js"
export * from "./DanhSachNoTienPhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports